// extracted by mini-css-extract-plugin
export default {"buy":"buy_buy__K5jwr","paper":"buy_paper__OYkFU"};